import React, { useEffect, useRef, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import { Button, Col, Row, Table, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import qs from 'qs';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import routes from '../../../controller/Routes';
import ShareTestModal from '../component/modal/ShareTestModal';
import { CopyOutlined, UserOutlined } from '@ant-design/icons';
import { reverse } from 'named-urls';
import { useTestStore } from "../../../store/testReducer";
import moment from "moment";
import { getAllInvitation } from '../../../controller/api/invitationServices';
import { getAdminDetail } from '../../../controller/localStroageHandler';
import { render } from '@testing-library/react';

const Invitation = () => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [textLink, setTestLink] = useState(false);
  const [testId, setTestID] = useState('')
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [technologiesList, setTechnologyList] = useState([]);
  const {
    updateTestDetail,
    updateDuration,
    updateTitle,
    updateProfile,
    updateTechnologyUsed,
    updateTest,
    clearStore
  } = useTestStore(state => state)
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const userDetail = getAdminDetail();
  useEffect(() => {
    getAllInvitation({ id: userDetail?.organization_id?._id }).then(res => {
      setData(res?.data?.data)
      // setTotal(res?.data?.total)
    }).catch(err => {
      console.log("err ===>", err)
    })
  }, []);

  const columns = [
    {
      title: 'Email',
      dataIndex: 'email',
      className: 'fw-medium',
    },
    {
      title: 'Test Link',
      dataIndex: 'testLink',
      className: 'fw-medium',
      render: (testLink) => (
        <div className='bg-white border border-color p-1 w-100 d-flex justify-content-between align-items-center rounded-1'>
          <span
            className='text-truncate test-link prevent-select text-muted fw-medium'
            style={{ maxWidth: '200px', height: '27px' }}
          >
            {testLink}
          </span>{' '}
          <CopyOutlined
            className="text-color-custom"
            onClick={() => handleCopy(testLink)}
          />
        </div>
      )
    },
    {
      title: 'OTP',
      dataIndex: 'otp',
      className: 'fw-medium',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      filterSearch: true,
      filters: [
        {
          text: <span className="text-danger">Pending</span>,
          value: 'pending',
        },
        {
          text: <span className="text-warning">InProgress</span>,
          value: 'inprogress',
        },
        {
          text: <span className="text-success">Completed</span>,
          value: 'completed',
        },
      ],
      className: 'fw-medium',
      render: (text) => (
        <span
          className={`${text == 'completed'
              ? 'text-success'
              : text == 'inprogress'
                ? 'text-warning'
                : 'text-danger'
            }`}
        >
          {text}
        </span>
      )
    },
    {
      title: 'OTP Vaild Till',
      dataIndex: 'otpValidTill',
      className: 'fw-medium',
      render: (item) => {
        return moment(item).format('DD-MM-YYYY, h:mm:ss a')
      }
    },
    {
      title: "",
      dataIndex: '',
      render: (record) => (
        <div className='d-flex gap-4 text-color-custom justify-content-center'>
          <FontAwesomeIcon
            style={{ cursor: 'pointer' }}
            icon={faTrashCan}
            onClick={() => {

            }}
          />
        </div>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };
  const getRandomuserParams = (params) => ({
    results: params.pagination?.pageSize,
    page: params.pagination?.current,
    ...params,
  });
  const handleCopy = (test_link) => {
   
    navigator.clipboard
           .writeText(test_link)
           .then(() => {
             message.success('Text copied!');
           })
           .catch((error) => {
             console.error('Failed to copy text: ', error);
           });
   };
 

  return (
    <>
      <div className='w-100 h-100 p-4 bg-light'>
        <AdminSearchBarHeader search={search} setSearch={setSearch} />
        <Row align={'middle'} className='mt-4 mb-4'>
          <Col span={24} className='fs-6 fw-semibold'>
            All Invitation
          </Col>
        </Row>
        <Table
          className='table-container'
          scroll={{
            y: 450,
            x: 600,
          }}
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={data}
          pagination={{
            ...tableParams.pagination,
            showSizeChanger: true,
            total: total,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          }}
          loading={loading}
          onChange={handleTableChange}
        />
      </div>
      {textLink && <ShareTestModal textLink={textLink} setTestLink={setTestLink} testId={testId} setTestID={setTestID} />}
    </>
  );
};

export default Invitation;
